const isDevelopment = process.env.NODE_ENV === "development";

const PROD_API_BASE_URI =
  process.env["REACT_APP_BASE_URI"] || "https://potec.hap-technology.com/api-order";
export const API_BASE_URI = isDevelopment
  ? "https://potec.hap-technology.com/api-order"
  : PROD_API_BASE_URI;

export const KEY_RECAPTCHA = isDevelopment
  ? "6LdwRNAbAAAAAO6W3Owm1RiYvhKSJose2Q_jnoYc"
  : process.env["REACT_APP_CAPTCHA_KEY_PRODUCT"];

export const PROD_LOCATION = isDevelopment
  ? process.env["REACT_APP_LOCATION_DEV_TEST"]
  : process.env["REACT_APP_LOCATION_DEV_PROD"];
const STATUS = {
  Initial: 0,
  Processing: 1,
  Finish: 2,
  Failed: 3,
};

const status_vn = {
  0: "Chờ thanh toán",
  1: "Chờ xác nhận ngày tiêm",
  2: "Đăng ký thành công",
  3: "Đã tiêm",
  4: "Đã hủy",
};

export const handleStatus = (x) => {
  switch (x) {
    case 0:
      return "Chờ thanh toán";
    case 1:
      return "Chờ xác nhận ngày tiêm";
    case 2:
      return "Đăng ký thành công";
    case 3:
      return "Đã tiêm";
    case 4:
      return "Đã hủy";

    default:
      return "Chờ thanh toán";
  }
};

export const numberWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const pad = (n) => {
  return n < 10 ? "0" + n : n;
};
export const sortPrioritize = (array1, array2) => {
  if (array1 && array1?.length > 0) {
    if (array2 && array2?.length > 0) {
      let temp = array1;
      for (let i = 0; i < array2.length; i++) {
        temp = temp.filter((x) => x.name !== array2[i].name.trim());
      }
      temp.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      //   console.log("temp", temp);

      let res = [];
      for (let i = 0; i < array2.length; i++) {
        let a = array1.filter((x) => x.name === array2[i].name.trim());
        res = res.concat(a);
      }
      //   console.log("res", a);
      let value = res.concat(temp);
      // console.log(value);
      return value;
    } else
      return array1.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }
  return null;
};

export const API_ENDPOINT = {
  GET_LIST_PROVINCES: "/order/provinces",
  GET_LIST_DISTRICTS: "/order/districts",
  GET_LIST_WARDS: "/order/wards",
  GET_LOCATION_MEDICINES: "/order/location-medicines",
  GET_LIST_PATHOGENS: "/order/pathogens",
  ORDER_REGISTER: "/order/order",
  ORDER_LOGIN: "/order/login",
  GET_LIST_VACCINE: "/order/vaccine",
  GET_INFO_USER: "/order/info-user",
  GET_ORDER_DETAIL: "/order/info-order",
  GET_GROUP_AGE: "/order/vaccine-group",
  CANCEL_REGISTER_ORDER: "/order/cancel-registration",
  USER_REGISTER: "/order/register",
  RESET_PASSWORD: "/order/reset-password",
  CHANGE_PASSWORD: "/order/update-password",
  USER_UPDATE: "/order/update-profile",
  UPDATE_TIME_ORDER: "/order/update-order",
};
export const RULES_ANTD = {
  common: {
    required: true,
    message: "Bạn chưa  nhập đầy đủ thông tin",
  },
  password: [
    {
      required: true,
      message: "Bạn chưa  nhập đầy đủ thông tin",
    },
    {
      min: 8,
      message: "Bạn phải nhập ít nhất 8 kí tự",
    },
  ],
  email: [
    { type: "email", message: "VD: abc@gmail.com" },
    {
      required: true,
      message: "Bạn chưa  nhập đầy đủ thông tin",
    },
  ],

  name: [
    { required: true, message: "Bạn chưa nhập họ tên" },
    {
      min: 3,
      message: "Bạn phải nhập ít nhất 3 kí tự",
    },
  ],

  gender: [{ required: true, message: "Bạn chưa nhập giới tính" }],

  code_note: [
    {
      required: true,
      message: "Bạn chưa nhập mã sổ tiêm ",
    },
  ],
  birth_day: [
    {
      required: true,
      message: "Bạn chưa chọn ngày sinh",
    },
  ],

  confirm_password: [
    {
      required: true,
      message: "Bạn chưa nhập đầy đủ thông tin",
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("AMV_register_password") === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error("Mật khẩu phải giống nhau"));
      },
    }),
  ],

  confirm_password_new: [
    {
      required: true,
      message: "Bạn chưa nhập đầy đủ thông tin",
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("AMV_password_new") === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error("Mật khẩu mới phải giống nhau"));
      },
    }),
  ],

  phone: [
    {
      required: true,
      // type: "regexp",
      pattern: new RegExp(/(84|0[3|5|7|8|9])+([0-9]{8})\b/g),
      message: "VD : 0912345678",
    },
  ],

  address: [
    {
      required: true,
      message: "Bạn chưa nhập địa chỉ",
    },
  ],
  provinces: [
    {
      required: true,
      message: "Bạn chưa chọn tỉnh thành",
    },
  ],
  districts: [
    {
      required: true,
      message: "Bạn chưa chọn quận huyện",
    },
  ],
  wards: [
    {
      required: true,
      message: "Bạn chưa chọn phường xã",
    },
  ],

  number_people_register: [
    {
      required: true,
      message: "Bạn chưa nhập số người",
    },
    {
      pattern: new RegExp(/^([1-9]{1})\b/g),
      message: "Số người từ  1 đến 9",
    },
  ],

  contact_person_1_phone_number: [
    {
      required: true,
      message: "Bạn chưa nhập người liên hệ ",
    },
  ],

  contact_relationship: [
    {
      required: true,
      message: "Bạn chưa chọn quan hệ ",
    },
  ],

  type_injection: [
    {
      required: true,
      message: "Bạn chưa chọn kiểu tiêm ",
    },
  ],
  location_medical: [
    {
      required: true,
      message:
        "Bạn chưa chọn địa điểm tiêm , nếu không có xin vui lòng chọn tỉnh khác ",
    },
  ],

  pathogen: [
    {
      required: true,
      message: "Bạn chưa chọn kháng nguyên ",
    },
  ],
  date_injection: [
    {
      required: true,
      message: "Bạn chưa chọn ngày tiêm ",
    },
  ],
};

export const getStoragePersist = (value) => {
  let persist = JSON.parse(localStorage.getItem("persist:root"));
  if (persist) {
    let auth = JSON.parse(persist.auth);
    if (auth.user != null) {
      let authInfo = auth.user;

      console.log(authInfo, "authInfo");
      switch (value) {
        case "id":
          return authInfo.userId;
        case "name":
          return authInfo.name;
        case "avatar":
          return authInfo.avatar;
        case "date":
          return authInfo.date;
        case "email":
          return authInfo.email;
        case "phone":
          return authInfo.phone;
        case "role":
          return authInfo.role;
        case "isAuth":
          return authInfo.isAuth;
        case "note":
          return authInfo.note;
        default:
          return authInfo.user;
      }
    }
    return null;
  }
  return null;
};
